import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Button, Box, Grid, TextField, Typography } from "@mui/material";
import { ValidatePhone } from "../Common/helpers";
import DebouncedMapBoxInput from "../Common/DebouncedMapBoxInput";

import MapBox from "../RealEstate/MapBox";
import MuiAlert from "@mui/lab/Alert";
import LoadingButton from "@mui/lab/LoadingButton";
import Localisation3 from "../Common/Localisation3";

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function AmbassadorDetailsStep2({ upperState, setUpperState, setBackDrop, setSnackState }) {
	const [complete, setComplete] = useState(false);


	const [state, setState] = useState(upperState);

	const [loadingState, setLoadingState] = useState(false);
	const handleChange = (event) => {
		setState({ ...state, [event.target.name]: event.target.value });
	};
	const handleChangeLoc = (loc) => {
		//console.log(loc.center[0], loc.center[1]);
		setState({ ...state, loc: loc, has_loc: true, full_adr: loc.Label });
	};

	useEffect(() => {
		console.log("useEffect", window.location.href);
		if (window.location.href.startsWith("http://localhost")) {
			setState({
				...state,
				phone1: "0637574129",
			});
		}
	}, []);
	useEffect(() => {
		console.log("useEffect", state);
		if (state.phone1 !== "" && state.has_loc && ValidatePhone(state.phone1)) {
			setComplete(true);
		} else {
			setComplete(false);
		}
	}, [state]);
	const manageSubmit = () => {
		//setBackDrop(true);
		setLoadingState(true);
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify(state),
		};

		fetch("/api/b8a185380e6340daa092a025e96656db", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						//setUpperState({ ...upperState, step: 2 });
						location.replace("/devenir-ambassadeur/2");
						break;

					case "err":
						setBackDrop(false);
						setSnackState({
							open: true,
							body: res.reason,
							severity: "error",
						});
						break;
					default:
						break;
				}
			});
	};

	return (
		<div style="padding-right: 10px; padding-left: 10px;">
			<div>
				<Typography variant="h5">Numéro de téléphone</Typography>
			</div>
			<div>
				<Box display="flex" alignItems="center" justifyContent="space-between" m={1} >
					<Box p={1} style="padding: 0px; margin: 0px;">
						<TextField
							id="phone1"
							name="phone1"
							variant="outlined"
							style={{
								marginLeft: 0,
								marginRight: 10,
							}}
							placeholder="Téléphone principal *"

							value={state.phone1}
							onChange={handleChange}
							margin="dense"
							size="small"
						/>
					</Box>
				</Box>
			</div>
			<div>
				<Typography variant="caption">Le numéro de téléphone peut être au format français "06XXXXXXXX"</Typography>
				<Typography variant="caption"> ou international "+33XXXXXXXX"</Typography>
			</div>


			<div style="margin-top: 20px;">
				<Typography variant="h5">Mon adresse personnelle</Typography>
			</div>
			<Localisation3 upperState={state} mode="AMB" upperSendLoc={handleChangeLoc} />

			<Box display="flex" alignItems="center" justifyContent="flex-end" p={1} m={1} style="padding: 0px; margin: 0px;">
				<Box p={1} style="padding: 0px; margin: 0px;">
					<LoadingButton loading={loadingState} onClick={manageSubmit} variant="contained" color="primary" disabled={!complete}>
						Suivant
					</LoadingButton>
				</Box>
			</Box>
		</div>
	);
}
